import React from 'react';

import '../styles/PolicyPages.css';

function TermsOfService() {
  return (
    <div className="policy-container">
      <h1>Terms of Service</h1>
      <p className="last-updated">Last Updated: December 5, 2025</p>

      <section>
        <h2>1. Acceptance of Terms</h2>
        <ul>
          <li>By accessing and using Kalinga Crafts Store, you accept and agree to be bound by these Terms of Service</li>
          <li>If you do not agree, please do not use our services</li>
        </ul>
      </section>

      <section>
        <h2>2. Use of Service</h2>
        <p>You agree to:</p>
        <ul>
          <li>Provide accurate and current information</li>
          <li>Maintain the security of your account</li>
          <li>Not use the service for any illegal purposes</li>
          <li>Not interfere with the proper functioning of the service</li>
        </ul>
      </section>

      <section>
        <h2>3. Product Information</h2>
        <ul>
          <li>We strive to provide accurate product descriptions and images</li>
          <li>However, we do not warrant that product descriptions or other content is accurate, complete, or error-free</li>
        </ul>
      </section>

      <section>
        <h2>4. Pricing and Payment</h2>
        <ul>
          <li>All prices are in Indian Rupees (INR)</li>
          <li>Prices are subject to change without notice</li>
          <li>Payment is processed securely through Razorpay</li>
          <li>We reserve the right to refuse or cancel orders</li>
        </ul>
      </section>

      <section>
        <h2>5. Order Acceptance</h2>
        <ul>
          <li>Your order is an offer to purchase products</li>
          <li>We reserve the right to accept or decline your order for any reason</li>
          <li>Reasons may include product availability, errors in pricing, or suspected fraud</li>
        </ul>
      </section>

      <section>
        <h2>6. Intellectual Property</h2>
        <ul>
          <li>All content on this site, including text, graphics, logos, and images, is the property of Kalinga Crafts Store</li>
          <li>All content is protected by copyright laws</li>
        </ul>
      </section>

      <section>
        <h2>7. Limitation of Liability</h2>
        <ul>
          <li>Kalinga Crafts Store shall not be liable for any indirect, incidental, special, or consequential damages</li>
          <li>This applies to damages arising from your use of our service</li>
        </ul>
      </section>

      <section>
        <h2>8. Governing Law</h2>
        <ul>
          <li>These Terms are governed by the laws of India</li>
          <li>Any disputes shall be subject to the exclusive jurisdiction of courts in India</li>
        </ul>
      </section>

      <section>
        <h2>9. Changes to Terms</h2>
        <ul>
          <li>We reserve the right to modify these Terms at any time</li>
          <li>Continued use of the service constitutes acceptance of modified terms</li>
        </ul>
      </section>

      <section>
        <h2>10. Contact Information</h2>
        <ul>
          <li>For questions about these Terms, contact us</li>
          <li><strong>Email:</strong> support@kalingastore.shop</li>
          <li><strong>Address:</strong> 12A, Old Vijay Nagar, Ghaziabad, Uttar Pradesh - 201001</li>
        </ul>
      </section>
    </div>
  );
}

export default TermsOfService;
